export class ToolGridViewModel {
    constructor() {
        this.name = "";
        this.discription = "";
        this.price = null;
    }
}
export default class ToolGridView extends ToolGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
